// The breakdown's public page on the classic site, in the classic ref spelling:
//   {REACT_APP_CWB_Site}/open-breakdown/{bdType}{id}
//   e.g. https://www.castingworkbook.com/open-breakdown/0161981
//   one type digit (0 film & TV, 2 commercial, 3 theatre), then the id with no
//   padding.
//
// Pass the API's classicRef. It goes through verbatim: the API builds it so this
// app never takes a ref apart (the leading zero is significant, and the padded
// breakdownId is a different spelling of the same thing). The classic page also
// resolves the padded spelling, so a caller with only a breakdownId still lands
// on the right breakdown — but classicRef is the one to link.
export const openBreakdownUrl = (ref: string): string =>
  `${process.env.REACT_APP_CWB_Site || ""}/open-breakdown/${encodeURIComponent(ref)}`;
